import { displayPointToPdf } from "./pdf-core.js";
import { baseFileName } from "./file-name-core.js";

export const FULL_CROP = Object.freeze({ x: 0, y: 0, width: 1, height: 1 });

export function normalizeCrop(crop) {
  const minimum = .05;
  const requestedWidth = Number(crop?.width);
  const requestedHeight = Number(crop?.height);
  const requestedX = Number(crop?.x);
  const requestedY = Number(crop?.y);
  const width = Math.min(1, Math.max(minimum, Number.isFinite(requestedWidth) ? requestedWidth : 1));
  const height = Math.min(1, Math.max(minimum, Number.isFinite(requestedHeight) ? requestedHeight : 1));
  return {
    x: Math.min(1 - width, Math.max(0, Number.isFinite(requestedX) ? requestedX : 0)),
    y: Math.min(1 - height, Math.max(0, Number.isFinite(requestedY) ? requestedY : 0)),
    width,
    height
  };
}

export function cropFromInsets({ top = 0, right = 0, bottom = 0, left = 0 }) {
  const values = [top, right, bottom, left].map(value => Math.min(90, Math.max(0, Number(value) || 0)) / 100);
  const horizontal = values[1] + values[3];
  const vertical = values[0] + values[2];
  const scaleX = horizontal > .95 ? .95 / horizontal : 1;
  const scaleY = vertical > .95 ? .95 / vertical : 1;
  const normalizedLeft = values[3] * scaleX;
  const normalizedRight = values[1] * scaleX;
  const normalizedTop = values[0] * scaleY;
  const normalizedBottom = values[2] * scaleY;
  return normalizeCrop({
    x: normalizedLeft,
    y: normalizedTop,
    width: 1 - normalizedLeft - normalizedRight,
    height: 1 - normalizedTop - normalizedBottom
  });
}

export function insetsFromCrop(crop) {
  const value = normalizeCrop(crop);
  return {
    top: Math.round(value.y * 100),
    right: Math.round((1 - value.x - value.width) * 100),
    bottom: Math.round((1 - value.y - value.height) * 100),
    left: Math.round(value.x * 100)
  };
}

export function cropRectToPdf(crop, cropBox, rotation) {
  const value = normalizeCrop(crop);
  const viewportWidth = rotation % 180 === 0 ? cropBox.width : cropBox.height;
  const viewportHeight = rotation % 180 === 0 ? cropBox.height : cropBox.width;
  const x1 = value.x * viewportWidth;
  const y1 = value.y * viewportHeight;
  const x2 = (value.x + value.width) * viewportWidth;
  const y2 = (value.y + value.height) * viewportHeight;
  const points = [
    displayPointToPdf(x1, y1, cropBox, rotation), displayPointToPdf(x2, y1, cropBox, rotation),
    displayPointToPdf(x1, y2, cropBox, rotation), displayPointToPdf(x2, y2, cropBox, rotation)
  ];
  const xs = points.map(point => point.x);
  const ys = points.map(point => point.y);
  return { x: Math.min(...xs), y: Math.min(...ys), width: Math.max(...xs) - Math.min(...xs), height: Math.max(...ys) - Math.min(...ys) };
}

export function croppedPdfName(name) {
  return `${baseFileName(name || "document.pdf")}-cropped.pdf`;
}
